<div class="base-page-banner">

  @if (!pageSettings?.removeSearchBar) {
    <app-quick-search-input
      class="page-banner-search-input quick-search"
      [ariaLabel]="'COMMON.search_the_catalog' | translate"
      [bundle]="searchBundles"
      (search)="navigateSearchPage($event)">
    </app-quick-search-input>
  }

  <h1 class="page-banner-title">
    {{ pageSettings?.title || ('COMMON.catalog' | translate)}}
    <label class="offline-mode-indicator" *ngIfOffline="false">{{"COMMON.offline_mode" | translate}}</label>
  </h1>

  @if (!pageSettings?.removeBannerShadow) {
    <div class="page-banner-overlay"></div>
  }

  <img
    class="page-banner-image"
    *ngIfMediaQuery="'(min-width: 640px)'; else mobileImageTmp"
    [cropImage]="pageSettings?.image | settingsMediaPresignedUrl | async"
    [additionalOptions]="{ height: 320 }"
    alt="Banner image">

  <ng-template #mobileImageTmp>
    @if (pageSettings?.phoneImage || pageSettings?.image; as image) {
      <img
        class="page-banner-image"
        [cropImage]="image | settingsMediaPresignedUrl | async"
        [additionalOptions]="{ height: 240 }"
        alt="Banner image">
    }
  </ng-template>
</div>
